import fp from "lodash/fp";

import { sourceFilterFilesConstants } from "./filterFiles.constants";

export const sourceFilterFilesActions = {
	resetFilters,
	setFilters,
	removeFilter,
};

function resetFilters() {
	return {
		type: sourceFilterFilesConstants.RESET_FILTERS,
	};
}
function setFilters({ ...filters }, tab) {
	return fp.flow(fp.pickBy(fp.identity), fs => ({
		type: sourceFilterFilesConstants.SET_FILTERS,
		filters: fs,
		tab,
	}))(filters, tab);
}

function removeFilter(filterName) {
	return {
		type: sourceFilterFilesConstants.REMOVE_FILTER,
		filterName,
	};
}
